import { render, staticRenderFns } from "./Viewbusiness.vue?vue&type=template&id=74d19326&scoped=true&"
import script from "./Viewbusiness.vue?vue&type=script&lang=js&"
export * from "./Viewbusiness.vue?vue&type=script&lang=js&"
import style0 from "./Viewbusiness.vue?vue&type=style&index=0&id=74d19326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d19326",
  null
  
)

export default component.exports